exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rasa-tooltip div {\r\n  color: var(--grey-700);\r\n  font-weight: bold;\r\n  background: var(--grey-100);\r\n  border: 1px solid var(--grey-700);\r\n}\r\n.rasa-help {\r\n  padding-left: 5px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/help/styles.css
// module id = 1698
// module chunks = 29